import clsx from "clsx";
import React from "react";

import styles from "./styles.module.css";

export interface SkeletonProps {
  /** Width of the placeholder block. Size to the region being replaced —
   * layout must not shift when real content lands. */
  width?: number | string;
  /** Height of the placeholder block. */
  height?: number | string;
  /** Radius override (defaults to the elevation-3 token via CSS). */
  borderRadius?: number | string;
  className?: string;
}

/**
 * Token-driven loading placeholder (M3 async loading contract).
 *
 * - Decorative only: `aria-hidden`, no role, no content. The consuming
 *   region carries `aria-busy` plus a visually hidden loading announcement
 *   (see the Button `loadingText` pattern).
 * - Anti-flicker: the block fades in after a short delay so sub-200ms
 *   queries never flash a skeleton (CSS `--skeleton-appear-delay`).
 * - Motion: the shimmer pulse runs only under
 *   `prefers-reduced-motion: no-preference`; otherwise the block is static.
 * - Deliberately minimal API — size and radius only.
 */
export function Skeleton(props: SkeletonProps) {
  const { borderRadius, className, height, width } = props;

  return (
    <div
      aria-hidden="true"
      className={clsx(styles.skeleton, className)}
      data-skeleton=""
      data-testid="t--wds-skeleton"
      style={{ width, height, borderRadius }}
    />
  );
}
